export const Select = {
  variants: {
    default: {
      field: {
        height: '40px',
        width: 'auto',
        borderRadius: '8px',
        transition: '0.2s ease-out',
        bg: 'white',
        boxShadow: '0px 2px 4px -2px #00000005',
        _placeholder: {
          color: 'solid.300',
          opacity: 1,
        },
        _focus: {
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        },
        _hover: {
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        },
        _active: {
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        },
        _disabled: {
          bg: 'solid.100',
          border: 'none',
          outline: 'none',
        },
        color: 'solid.900',
        textStyle: 'l-s',

        borderWidth: '1px',
        borderColor: 'solid.100',
        outline: 'none',
      },
      icon: {
        color: 'solid.500',
        width: 'auto',
        minW: '1rem',
        maxW: '2rem',
        flexShrink: 0,
      },
    },
    editable: {
      field: {
        width: '208px',
        borderRadius: '8px',
        height: '30px',
        transition: '0.2s ease-out',
        bg: 'white',
        boxShadow: '0px 2px 4px -2px #00000005',

        _focus: {
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        },
        _hover: {
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        },
        _active: {
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        },
        _disabled: {
          bg: 'solid.100',
          border: 'none',
        },
        color: 'solid.900',
        textStyle: 'l-s',

        borderWidth: '1px',
        borderColor: 'solid.100',
      },
      icon: {
        color: 'solid.500',
        width: 'auto',
        minW: '1rem',
        maxW: '2rem',
        flexShrink: 0,
      },
    },
    countries: {
      field: {
        width: '100%',
        textIndent: '40px',
        gap: '12px',
        borderRadius: '8px',
        borderWidth: '1px',
        borderColor: 'solid.100',
        bg: 'white',
      },
      icon: {
        width: 'auto',
        minW: '1rem',
        maxW: '2rem',
        flexShrink: 0,
      },
    },
    forms: {
      field: {
        borderRadius: '8px',
        borderWidth: '1px',
        borderColor: 'solid.100',
        textStyle: 'l-s',
        color: 'solid.900',
        _placeholder: {
          color: 'solid.300',
          opacity: 1,
        },
        _focus: {
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        },
        _hover: {
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        },
        _active: {
          boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
          border: 'solid.100',
          outline: 'solid.100',
        },
        _disabled: {
          bg: 'solid.100',
          border: 'none',
        },
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
}
